<template>
  <div class="shipment-page">
    <shipment-page-stats v-if="false" />
    <div class="features f-r-vc">
      <el-button
        type="primary"
        class="feature-button deep-green-bg"
        @click="openNewShipment"
      >
        <svg-icon icon-class="plus" class="svg-white-color" />
        Create Shipment
      </el-button>
    </div>
    <div class="shipment-list" v-loading="loadingShipment">
      <el-tabs v-model="queryStatus">
        <el-tab-pane
          v-for="(tab, index) in Tabs"
          :key="'order-tab-' + index"
          :label="tab"
          :name="tab"
        />
      </el-tabs>
      <searchable-table
        :table-headers="ShipmentTableHeaders"
        :table-data="shipmentPage"
        :search-params="searchForm"
        :hasRowExpand="true"
        :actionWidth="120"
        :search-param-change="searchParamChange"
        :rowClassName="rowClass"
        :has-actions="true"
      >
        <template v-slot:actions="props">
          <div class="actions f-r">
            <el-button
              size="small"
              type="text"
              class="danger-text"
              @click="openReadyShipment(props.row.no)"
              v-if="showShipmentReadyBut(props.row)"
            >
              Ready
            </el-button>
            <el-button
              size="small"
              type="text"
              @click="goToShipmentDetail(props.row.no)"
            >
              Detail
            </el-button>
          </div>
        </template>
        <template #[palletCountSlot]="props">
          <span class="bold-oswald pallet-count">
            {{ props.row.palletCount }}
          </span>
        </template>
        <template #[loadedCountSlot]="props">
          <span class="bold-oswald pallet-count">
            {{ props.row.loadedCount }}
          </span>
        </template>
        <template #[destSlot]="props">
          <div class="f-r-hc dest-slot">
            <div
              class="dest-wrapper"
              v-for="address in getShipmentAddress(props.row)"
              :key="address.id"
            >
              <address-tag :address="address" trigger="click" />
            </div>
          </div>
        </template>
        <template v-slot:row-expand="props">
          <div class="expand-container">
            <stock-list
              :showActions="false"
              :stockQuery="{ shipmentId: props.row.id, onlyShipped: true }"
              :showHeaderOps="false"
            />
          </div>
        </template>
      </searchable-table>
    </div>
    <ready-shipment ref="readyShipment" />
    <common-dialog
      ref="dialog"
      title="New Shipment"
      :showResetBtn="false"
      :width="35"
    >
      <template v-slot:content>
        <div class="new-shipment-container f-r">
          <div class="left f-c-hc">
            <span class="left-count bold-oswald">Count</span>
            <div class="left-count f-r-hsb f-r-vc">
              <svg-icon
                icon-class="minus"
                class="svg-business-color op-icon"
                @click.native="subShipmentCount"
              />
              <span class="light-oswald new-count">{{ newShipmentCount }}</span>
              <svg-icon
                icon-class="plus"
                class="svg-business-color op-icon"
                @click.native="addShipmentCount"
              />
            </div>
            <el-button type="primary" @click="createEmptyShipment">
              Create Empty Nos
            </el-button>
          </div>
          <div class="right f-c-c-c" @click="goToStock">
            <span class="but-text">Select Pallets</span>
            <span class="but-text">From Stock</span>
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>

<script>
import set from 'lodash/set'
import debounce from 'lodash/debounce'
// mixins
import { pageJumps } from '@/core/mixin/pages'
// components
import SearchableTable from '@/components/common/SearchableTable.vue'
import StockList from '@/components/shipment/StockList.vue'
import ShipmentPageStats from '@/components/shipment/ShipmentPageStats.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import AddressTag from '@/components/address/AddressTag.vue'
import ReadyShipment from '@/components/shipment/ReadyShipment.vue'
// model
import {
  ShipmentStatus,
  ShipmentTableHeaders,
  ShipmentSearchForm,
  ShipmentSearchParamsWrapUp,
  ShipmentWorking,
  ShipmentShipping,
  ShipmentDelivered,
  ShipmentDeleted
} from '@/core/models/shipment'
import { createShipment, queryShipment } from '@/api/shipment'
import { InitSearchForm } from '@/core/configs/types'
import { queryAddress } from '@/api/address'
export default {
  name: 'ShipmentPage',
  components: {
    SearchableTable,
    StockList,
    ShipmentPageStats,
    CommonDialog,
    AddressTag,
    ReadyShipment
  },
  mixins: [pageJumps],
  data() {
    return {
      loadingShipment: true,
      ShipmentTableHeaders,
      shipmentPage: null,
      addressMap: {},
      searchForm: InitSearchForm(ShipmentSearchForm, ShipmentTableHeaders),
      expands: [],
      debounceFetch: debounce(this.fetchShipments, 300),
      newShipmentCount: 1,
      palletCountSlot: 'palletCount',
      loadedCountSlot: 'loadedCount',
      destSlot: 'dest'
    }
  },
  watch: {
    queryStatus: {
      handler: function () {
        switch (this.queryStatus) {
          case ShipmentWorking:
          case ShipmentShipping:
          case ShipmentDelivered:
          case ShipmentDeleted:
            this.debounceFetch()
            break
          default:
            this.goToSearchShipment({ status: ShipmentWorking }, true)
            break
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    Tabs() {
      return Object.values(ShipmentStatus)
    },
    queryStatus: {
      get() {
        return this.$route.query?.status
      },
      set(value) {
        this.goToSearchShipment({ status: value })
      }
    }
  },
  methods: {
    rowClass(row) {
      let classes = 'row_min_height '
      if (row.status !== ShipmentDeleted && row.palletCount === 0) {
        classes += 'empty-shipment-row '
      }
      if (this.showShipmentReadyBut(row)) {
        classes += 'ready-shipping-row '
      }
      return classes
    },
    curTime() {
      return new Date()
    },
    searchParamChange(key, path, value) {
      set(this.searchForm[key], path, value)
      this.debounceFetch()
    },
    fetchShipments() {
      this.loadingShipment = true
      const searchForm = ShipmentSearchParamsWrapUp(
        this.queryStatus,
        this.searchForm
      )
      queryShipment(searchForm)
        .then(async res => {
          const addressIds = res.records.reduce((acc, cur) => {
            if (cur.addressIds) acc.push(...cur.addressIds.split(','))
            return acc
          }, [])
          const addressPage = await queryAddress({ addressIds, size: -1 })
          if (addressPage) {
            this.addressMap = Object.fromEntries(
              addressPage.records.map(one => [one.id, one])
            )
          }
          this.shipmentPage = res
        })
        .finally(() => {
          this.loadingShipment = false
        })
    },
    getShipmentAddress(shipment) {
      const addressIds = shipment.addressIds?.split(',') ?? []
      return addressIds.map(one => this.addressMap[one])
    },
    addShipmentCount() {
      this.newShipmentCount = Math.min(12, this.newShipmentCount + 1)
    },
    subShipmentCount() {
      this.newShipmentCount = Math.max(1, this.newShipmentCount - 1)
    },
    openNewShipment() {
      this.$refs.dialog.open()
    },
    showShipmentReadyBut(shipment) {
      if (shipment.status !== ShipmentWorking) return false
      return (
        shipment.palletCount > 0 &&
        shipment.palletCount === shipment.loadedCount
      )
    },
    openReadyShipment(shipmentNo) {
      this.$refs.readyShipment.open(shipmentNo, this.debounceFetch)
    },
    async createEmptyShipment() {
      await this.$confirm(
        `Create ${this.newShipmentCount} empty shipments, continue?`,
        'Warning',
        {
          confirmButtonText: 'Continue',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          createShipment({
            isEmpty: true,
            count: this.newShipmentCount
          })
            .then(res => {
              this.$message.success(
                `Successfully created ${res.count} new empty shipments`
              )
              this.$refs.dialog.close()
            })
            .catch(_ => {})
            .finally(() => {
              this.debounceFetch()
            })
        })
        .catch(() => {})
    }
  },
  mounted() {
    this.debounceFetch()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.shipment-page {
  width: 100%;
  overflow-x: hidden;

  @extend .f-c;

  .features {
    @extend .global-margin;
  }

  .shipment-list {
    @extend .global-margin;
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }
}

.expand-container {
  padding: 0 10px;
  margin-right: 100px;

  @extend .inner-table-override;
}

.pallet-count {
  font-size: 18px;
  font-weight: bold;
  color: black;
}

.new-shipment-container {
  gap: 1rem;

  .left {
    user-select: none;
    flex-basis: 40%;
    flex-grow: 1;
    flex-shrink: 0;
    border: 2px solid $business-color;
    border-radius: $home-card-border-radius;
    padding: 1rem;
    gap: 10px;

    .el-input-number {
      @extend .bold-oswald;
    }

    .left-count {
      font-size: 36px;
      text-align: center;
    }

    .new-count {
      font-size: 46px;
    }

    .op-icon {
      color: rgba($business-color, 0.8);

      &:hover {
        cursor: pointer;
        color: rgba($business-color, 0.7);
      }

      &:active {
        color: rgba($business-color, 0.9);
      }
    }
  }

  .right {
    flex-basis: 40%;
    flex-grow: 1;
    flex-shrink: 0;
    background-color: rgba($business-color, 0.85);
    border-radius: $home-card-border-radius;
    padding: 1rem;
    gap: 1rem;
    user-select: none;

    &:hover {
      cursor: pointer;
      background-color: rgba($business-color, 0.7);
    }

    &:active {
      background-color: rgba($business-color, 0.95);
    }

    .but-text {
      font-size: 24px;
      color: white;
    }
  }
}

.actions {
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px 10px;

  .el-button {
    margin: 0 !important;
  }
}

.dest-slot {
  gap: 10px;
  flex-wrap: wrap;

  .dest-wrapper {
    border: 1px solid $business-color;
    border-radius: 3px;
    padding: 0 5px;
    height: 100%;
    overflow: hidden;
  }
}
</style>
